import React, { useEffect, useState } from 'react'
import { useChangeSupplierProductStatusMutation, useCreateSupplierProductMutation, useDeleteSupplierProductMutation, useSupplierProductByIdQuery, useSupplierProductsQuery, useUpdateSupplierProductMutation } from '../../../Store/Apis/supplierApis'
import Error from '../../../Components/Error/Error';
import Loader from '../../../Components/Loader/Loader';
import AddEditSupplierProduct from '../../../Components/AddEditSupplierProduct/AddEditSupplierProduct';
import toast from 'react-hot-toast';
import { Modal } from 'react-bootstrap';
import { useSelector } from 'react-redux';

const SuppliersProducts = () => {
  const user = useSelector((state) => state.auth.user);
  // page 1 for listing
  // page 2 for add
  // page 3 for edit
  const [page, setPage] = useState()
  const [sortFilter, setSortFilter] = useState({
    search: '',
    filter: '',
    outletID: ''
  });
  const supplierProductsApi = useSupplierProductsQuery({
    keyword: sortFilter.search,
    outletID: sortFilter.outletID
  })

  // CREATE PRODUCT
  
  const [createSupplierProductMutation] = useCreateSupplierProductMutation()
  const handleCreate = (formData) => {
    console.log(formData)
    createSupplierProductMutation({
      outletId: formData.outletId,
      supplierId: formData.supplierId,
      categoryId: formData.categoryId,
      productName: formData.productName,
      isActive: 1,
    }).then((res)=>{
      if (res?.data?.status === 200) {
        setPage(1)
        toast.success(res?.data?.message, { duration: 7000 });
      } else {
        toast.error(res?.error?.data?.message, { duration: 7000 });
      }
    })
  }

  // EDIT PRODUCT
  const [selectedEditId, setSelectedEditId] = useState()
  const [EditSupplierProductMutation] = useUpdateSupplierProductMutation()
  const supplierProductById = useSupplierProductByIdQuery({
    keyId: selectedEditId
  }, {skip: !selectedEditId})
  const handleEdit= (formData) => {
    EditSupplierProductMutation({
      id: selectedEditId,
      outletId: formData.outletId,
      supplierId: formData.supplierId,
      categoryId: formData.categoryId,
      productName: formData.productName,
      isActive: 1,
    }).then((res)=>{
      if (res?.data?.status === 200) {
        setPage(1)
        toast.success(res?.data?.message, { duration: 7000 });
      } else {
        toast.error(res?.error?.data?.message, { duration: 7000 });
      }
    })
  }



  // STTAUS CHANGE
  const [selectedStatus, setSelectedStatus] = useState(null);
  const [changeStatus] = useChangeSupplierProductStatusMutation()
  const handleChangeStatus = () => {
      changeStatus(selectedStatus).then((res)=>{
        console.log(res)
        setSelectedStatus(null)
      })
  }

  // DELETE
  const [selectedRecord, setSelectedRecord] = useState(null);
  const [deleteCategory] = useDeleteSupplierProductMutation()
  const handleDelete = () => {
      deleteCategory(selectedRecord).then((res)=>{
        console.log(res)
        setSelectedRecord(null)
      })
  }


  useEffect(() => {
    if (user.role !== 'superAdmin') {
      setSortFilter({
        ...sortFilter,
        outletID: user.outletID
      });
    }    
  }, []);



  // ADD PRODUCT
  if(page === 2){
    return (
      <div>
        <div className="row align-items-center justify-content-between mb-3">
          <div className="col">
            <h5 className="fw-500 text-white mb-0">Add New Product</h5>
          </div>
          <div className="col-auto">
              <button 
                type='button'
                className="btn btn-icon btn-3 btn-white text-primary mb-0"
                onClick={()=> setPage(1)}
              >
                <i className="fa fa-arrow-left me-2"></i>  Back
              </button>
          </div>
        </div>
        <div className="card p-0">
          <div className="card-body">
            <AddEditSupplierProduct handleSubmit={handleCreate}/>
          </div>
        </div>
      </div>
    )
  }

  // EDIT PRODUCT
  if(page === 3){
    return (
      <div>
        <div className="row align-items-center justify-content-between mb-3">
          <div className="col">
            <h5 className="fw-500 text-white mb-0">Edit Product</h5>
          </div>
          <div className="col-auto">
              <button 
                type='button'
                className="btn btn-icon btn-3 btn-white text-primary mb-0"
                onClick={()=> setPage(1)}
              >
                <i className="fa fa-arrow-left me-2"></i>  Back
              </button>
          </div>
        </div>
        <div className="card p-0">
          <div className="card-body">
            <AddEditSupplierProduct handleSubmit={handleEdit} data={supplierProductById?.data?.data[0]}/>
          </div>
        </div>
      </div>
    )
  }

  return (
    <div>
      <div className="row align-items-center justify-content-between mb-3">
        <div className="col">
          <h5 className="fw-500 text-white">Products</h5>
        </div>
        <div className="col-auto">
            <button
              type='button' 
              className="btn btn-icon btn-3 btn-white text-primary mb-0"
              onClick={()=> setPage(2)}
            >
              <i className="fa fa-plus me-2"></i>  Add New Products
            </button>
            {/* <a className="btn btn-icon btn-3 btn-white text-primary mb-0 mx-1">
                <i className="fa fa-cloud-upload me-2"></i> Import Product
            </a> */}
        </div>
      </div>

      <div className="row">
        <div className="col-12">
          <div className="card mb-4">
            <div className="card-header p-4">
              <input 
                type="text" 
                className="form-control" 
                placeholder="Search by Product name"
                value={sortFilter?.search || ""}
                onChange={(e) => setSortFilter({...sortFilter, search: e.target.value})}  
              />
            </div>
            <div className="card-body p-0">
              {supplierProductsApi.isError && <Error/>}
              {supplierProductsApi.isLoading && <Loader height="500px"/>}
              {
                supplierProductsApi.isSuccess && (
                  <div className="table-responsive">
                    <div className="table align-items-center mb-0">
                      <table className="table align-items-center mb-0">
                        <thead className="bg-light">
                          <tr>
                            <th className="text-uppercase text-secondary text-xs opacity-7">#</th>
                            <th className="text-uppercase text-secondary text-xs opacity-7 ps-2"> Product Name</th>
                            <th className="text-uppercase text-secondary text-xs opacity-7 ps-2"> Outlet</th>
                            <th className="text-uppercase text-secondary text-xs opacity-7 ps-2"> Product Category</th>
                            <th className="text-uppercase text-secondary text-xs opacity-7 ps-2"> Supplier Name</th>
                            <th className="text-uppercase text-secondary text-xs opacity-7 ps-2">Status</th>
                            <th className="text-secondary opacity-7"></th>
                          </tr>
                        </thead>
                        <tbody>
                          {
                            supplierProductsApi.data.data.map((elem, i) => {
                              return(
                                <tr>
                                  <td>
                                    <p className="text-sm px-3 mb-0">{i+1} </p>
                                  </td>
                                  <td>
                                    <p className="text-sm mb-0">{elem.productName}</p>
                                  </td>
                                  <td>
                                    <p className="text-sm mb-0">{elem.outletName}</p>
                                  </td>
                                  <td>
                                    <p className="text-sm b-0 mb-0">{elem.categoryName}</p>
                                  </td>
                                  <td>
                                    <p className="text-sm mb-0">{elem.supplierName}</p>
                                  </td>

                                  <td className="align-middle text-center">
                                      <button 
                                        type='button' 
                                        className={`btn badge badge-xs ${elem.isActive == 1 ? 'badge-success': 'badge-danger'} fw-600 text-xs mb-0`} 
                                        onClick={() => setSelectedStatus({
                                            keyID: elem.id,
                                            isActive: elem.isActive == 1 ? 0 : 1
                                        })}
                                      >
                                          {elem.isActive == 1 ? 'Active': 'Deactivated'}
                                      </button> 
                                  </td>
                                  <td>
                                    <button 
                                      type='button' 
                                      className="badge badge-xs badge-warning fw-600 text-xs btn mb-0" 
                                      onClick={()=> (elem.supplierName !== 'Low Stock Entry' && setSelectedEditId(elem.id), setPage(3))}
                                      disabled={elem.supplierName === 'Low Stock Entry'}
                                    >
                                      Edit
                                    </button>
                                    <button 
                                      type='button'
                                      className="btn ms-2 badge badge-xs badge-danger text-xs fw-600 mb-0"
                                      onClick={()=>(elem.supplierName !== 'Low Stock Entry' && setSelectedRecord(elem.id))}
                                      disabled={elem.supplierName === 'Low Stock Entry'}
                                    >
                                      Delete
                                    </button>
                                  </td>
                                </tr> 
                              )
                            })
                          }
                        </tbody>
                      </table>
                    </div>
                  </div>
                )
              }
            </div>
          </div>
        </div>
      </div>

      {/* STATUS CHANGE MODAL */}
      <Modal 
          show={selectedStatus} 
          onHide={() => setSelectedStatus(null)} 
          size="sm" 
          centered
      >
          <Modal.Body className='text-center p-4'>
              <h5>Are you sure you want to change status?</h5>
              <div className="buttons d-flex gap-3 justify-content-center">
                  <button className='btn btn-danger bg-danger btn-sm mb-0' onClick={()=>(setSelectedStatus(null))}>Cancel</button>
                  <button className='btn btn-primary btn-sm mb-0' onClick={handleChangeStatus}>Confirm</button>
              </div>
          </Modal.Body>
      </Modal>

        {/* DELETE MODAL */}
        <Modal  
            show={selectedRecord} 
            onHide={() => setSelectedRecord(null)} 
            size="sm" 
            centered
        >
            <Modal.Body className='text-center p-4'>
                <h5>Are you sure you want to delete the brand?</h5>
                <div className="buttons d-flex gap-3 justify-content-center">
                    <button className='btn btn-danger bg-danger btn-sm mb-0' onClick={()=>(setSelectedRecord(null))}>Cancel</button>
                    <button className='btn btn-primary btn-sm mb-0' onClick={handleDelete}>Confirm</button>
                </div>
            </Modal.Body>
        </Modal>
    </div>
  )
}

export default SuppliersProducts